import React, {useEffect, useRef, useState} from "react";
import Swiper from 'swiper';
import 'swiper/swiper-bundle.min.css'
import "./SliderDesktop.scss"
import {LazyImage} from "../../../Components";


function AsyncImg({image}) {
    return(
        <div>
            Image...
        </div>
    )
}


function SliderDesktop(props) {


    const swiper = useRef(null)
    const Loop = ()=>{
        setInterval(()=>{
            try{
                swiper.current.slidePrev();
            }catch (e) {
                // console.log(e)
            }
        },8000)
    }




    useEffect(()=>{

        console.log("props ",props.item);

        const GoToSlide = (item) =>{

        }

        if(props.data){
            swiper.current=new Swiper(`.swiper-container-${props.uid}`,{
                pagination: {
                    el: ".swiper-pagination",
                },
                loop:true
            })
            try{
                swiper.current.on("click", function(e) {
                    /* do something */
                    // console.log(this.clickedSlide.attributes[1].value);
                    // console.log(props.data[parseInt(this.clickedSlide.attributes[1].value)])
                    let item = props.data[parseInt(this.clickedSlide.attributes[1].value)];
                    props.dispatch(item.link_to,item)
                });
            }catch (e) {
                // console.log(e)
            }

        }
        Loop();
    },[])

    // onClick={() => props.dispatch(item.link_to,item)}
    return(
        <div className="slider_container"
             style={{overflowX:"hidden",backgroundImage: props.item && props.item.background_image? `url(${props.item.background_image})` : ''}}
        >
            {props.data?<div className={`swiper-container-${props.uid} swiper1`}>
                <div className="swiper-wrapper">
                    {props.data.map(item=>{
                        return(
                            <div key={item.uid} className="swiper-slide" >
                                {/*<img alt={"slider"+item.uid}  src="https://dkstatics-public.digikala.com/digikala-adservice-banners/cb0f5d684a8ea32ddef589caa02f3844ce61a376_1667222487.jpg?x-oss-process=image/quality,q_95" />*/}
                                <img alt={"slider"+item.uid}  src={item.image_desktop} />
                                {/*<LazyImage type={"slide"} src={item.image}/>*/}
                            </div>
                        )
                    })}
                </div>
                <div className="swiper-pagination"></div>
            </div>:null}
        </div>
    )
}

export default SliderDesktop;
